import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    padding: 3em 8em 6em 8em;
    background-color: ${vars.colorSecondary};
    border-radius: 0.5em;
    text-align: center;

    .contact-form-body {
        max-width: 29em;
    }

    .contact-form-header {
        margin: 0 0 2.5em 0;

        .contact-header-headline {
            font-size: 2.8em;
            line-height: 3.5rem;
            display: flex;
            flex-direction: column;
        }

        .contact-description {
            font-size: 0.9em;
            margin: 20px;
        }

        .highlighted {
            color: ${vars.colorViolet};
        }
    }

    .form {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    @media screen and (max-width: ${vars.desktopS}) {
        padding: 3em 4em 6em 4em;
    }

    @media screen and (max-width: ${vars.mobileM}) {
        padding: 3em 2em 2em;
    }
`;
